import React from "react";

const Divider = ( props ) => {
    return (
        <div className={`container-fluid divider-section${props.additionalClasses ? " " + props.additionalClasses : ""}`}>
            {props.children}
        </div>
    )
}

export default Divider;